import React, { useState, useCallback, useEffect } from "react";
import { producaov2 as api } from "../../../../services/apis";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import Footer from "../../../../components/Footer";
import ListaEspera from "../../../../components/ListaEspera";
import { Container, Box, Header, FormBlock } from "./styles";
import { isAuthAdmin } from "../../../../services/auth";

import swal from "sweetalert";
import {
  Form,
  Input,
  FormField,
  FormGroup,
  Button,
  Select,
} from "semantic-ui-react";
import { useRouter } from "../../../../hooks/router";

const RelatorioListaEspera = () => {
  document.title = "Painel Administrativo | Grupo Voitto";

  return (
    <>
      <AdminMenu />
      <Container>
        <Header>Lista de Espera</Header>

        <ListaEspera />
      </Container>
      <Footer />
    </>
  );
};

export default RelatorioListaEspera;
